import { AdItem } from '@sbt-web/network/types';
import { Item } from '@/shared/models';

// Define if interstitial is enabled
const isInterstitialEnabled = (item: Item): boolean => {
  const { kind } = item;

  if (kind === 'GeoboostItem') {
    // The geoboost carousel will handle the skip of the interstitial if needed
    return true;
  }

  let targetAd: AdItem | undefined;
  if (kind === 'AdItem') {
    targetAd = item;
  } else if (kind === 'DecoratedItem') {
    targetAd = item.item;
  } else if (kind === 'GalleryItem') {
    targetAd = item.adItem;
  }

  return targetAd ? !targetAd.advertiser.proPremiumDetailEnabled : false;
};

export { isInterstitialEnabled };
